import { defineEntity, custom, lifecycle } from './_helpers.js';

export default defineEntity('exercise', {
    reviewDue: lifecycle(),
    started: custom({ scope: 'state' }),
    'bcp.linked':              custom({ scope: 'state' }),
    'bcp.unlinked':            custom({ scope: 'state' }),
    'vendor.linked':           custom({ scope: 'state' }),
    'vendor.unlinked':         custom({ scope: 'state' }),
    'team.linked':             custom({ scope: 'state' }),
    'team.unlinked':           custom({ scope: 'state' }),
    'participant.linked':      custom({ scope: 'state' }),
    'participant.unlinked':    custom({ scope: 'state' }),
    'assessment.linked':       custom({ scope: 'state' }),
    'assessment.unlinked':     custom({ scope: 'state' }),
    'timeline.linked':         custom({ scope: 'state' }),
    'timeline.unlinked':       custom({ scope: 'state' }),
    'recoveryActivity.linked': custom({ scope: 'state' }),
    'recoveryActivity.unlinked': custom({ scope: 'state' }),
    'evaluation.linked':       custom({ scope: 'state' }),
    'evaluation.unlinked':     custom({ scope: 'state' }),
    'improvement.linked':      custom({ scope: 'state' }),
    'improvement.unlinked':    custom({ scope: 'state' }),
    'lessonLearned.linked':    custom({ scope: 'state' }),
    'lessonLearned.unlinked':  custom({ scope: 'state' }),
});
